import { createAction } from '@reduxjs/toolkit';

import { FetchCourseUserProfilesPayload, SetCourseUserProfilesPayload } from './types';

export const fetchCourseUserProfiles = createAction<FetchCourseUserProfilesPayload>(
  'users/profile/course/fetch'
);
export const setCourseUserProfiles = createAction<SetCourseUserProfilesPayload>('users/profile/course/set');
